<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-container">
        <div class="footer-section">
          <img style="width:100px;height:100px" src="../assets/logo.png" alt="logo" />
          <!-- <h3>雪顶科技</h3> -->
          <p>专注于为企业提供高效的数字化解决方案，致力于成为行业领先的技术服务商。</p>
          <div class="social-links">
            <!-- <span class="social-item">微信：kongxueding</span> -->
            <!-- <span class="social-item">邮箱：2294788755@qq.com</span> -->
          </div>
        </div>
        
        <div class="footer-section">
          <h4>产品服务</h4>
          <ul>
            <li><router-link to="/products">小红书团购SAAS系统</router-link></li>
            <li><router-link to="/products">微短剧SAAS系统</router-link></li>
            <li><router-link to="/products">IPTV C2分发系统</router-link></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>合作伙伴</h4>
          <ul>
            <li><router-link to="/partners">渠道合作</router-link></li>
            <li><router-link to="/partners">技术合作</router-link></li>
            <li><router-link to="/partners">战略合作</router-link></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>关于我们</h4>
          <ul>
            <li><router-link to="/about">公司介绍</router-link></li>
            <li><router-link to="/about">团队介绍</router-link></li>
            <li><router-link to="/about">联系我们</router-link></li>
          </ul>
        </div>
        
        <div class="footer-section contact-info">
          <h4>联系方式</h4>
          <div class="contact-item">
            <span class="contact-label">客服热线：</span>
            <span class="contact-value">400-688-5235</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">商务合作：</span>
            <span class="contact-value">17839217339</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">技术支持：</span>
            <span class="contact-value">2294788755@qq.com</span>
          </div>
        </div>
      </div>
    </div>
    
    <div class="footer-bottom">
      <div class="footer-container">
        <div class="copyright">
          <p>&copy; 2018-2026 雪顶科技. 保留所有权利 | 
            <span>ICP备案号：豫ICP备19013507号-1</span>
            <!-- <span>京公网安备xxxxxxxxxxxxxxxx号</span> -->
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background: linear-gradient(135deg, #2c3e50 0%, #1a252f 100%);
  color: #ecf0f1;
  padding-top: 80px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  padding-bottom: 40px;
}

.footer-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
}

.footer-section h3 {
  color: #3470ff;
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: 700;
  letter-spacing: 1px;
}

.footer-section h4 {
  color: #ecf0f1;
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: 600;
}

.footer-section p {
  line-height: 1.6;
  margin-bottom: 20px;
  color: #bdc3c7;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 10px;
}

.footer-section ul li a {
  color: #bdc3c7;
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-section ul li a:hover {
  color: #3470ff;
  transform: translateX(5px);
}

.social-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.social-item {
  color: #bdc3c7;
  font-size: 14px;
}

.contact-info .contact-item {
  display: flex;
  margin-bottom: 12px;
  align-items: center;
}

.contact-label {
  color: #ecf0f1;
  font-weight: 500;
  min-width: 80px;
}

.contact-value {
  color: #3470ff;
  font-weight: 600;
}

.footer-bottom {
  border-top: 1px solid #34495e;
  padding: 20px 0;
  background: rgba(0, 0, 0, 0.2);
}

.copyright {
  text-align: center;
}

.copyright p {
  color: #95a5a6;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.copyright span {
  margin: 0 5px;
}

@media (max-width: 768px) {
  .footer-container {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .footer {
    padding-top: 40px;
  }
  
  .contact-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .contact-label {
    margin-bottom: 4px;
  }
  
  .copyright p {
    font-size: 12px;
  }
}
</style> 
 